import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Notification} from "../model/notification.model";
import {retryAfterMillis} from "../shared/constants";

@Injectable({providedIn: 'root'})
export class NotificationService {

  private notifications: Notification[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('notifications', {
      limit: 10
    })
      .subscribe(response => {
        let notifications: Notification[] = [];
        for (const notification of response) {
          notifications.push({
            id: notification.id,
            title: notification.title,
            message: notification.message,
            icon: notification.icon,
            category: notification.category,
            notified: notification.notifiedMillis,
            watched: notification.watchedMillis
          });
        }
        this.notifications = notifications;
      }, err => {
        this.apiService.error({}, err);
        setTimeout(() => this.load(), retryAfterMillis);
      });
  }

  getNotifications() {
    return this.notifications;
  }
}
